import { Button, ButtonToolbar, Col, Row } from 'react-bootstrap'
import React, { Component } from 'react'
import {
  addButtonDisabled,
  configureButtonDisabled,
  deleteButtonDisabled,
  loading,
  refreshButtonDisabled,
  renameButtonDisabled,
  selected,
  selectedMailTargetLink,
  size,
  uri
} from '../../subs'
import {
  configureMailTarget,
  editMailTargetName,
  refresh,
  startConfirmingDeletion,
  startCreating
} from '../../actions'

import Indicator from 'components/Indicator'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import t from 'translate'

class Toolbar extends Component {
  static propTypes = {
    companyKey: PropTypes.string.isRequired
  }

  rename = () => {
    this.props.editMailTargetName(this.props.selectedMailTargetLink)
  }

  configure = () => {
    this.props.configureMailTarget(this.props.selectedMailTargetLink)
  }

  delete = () => {
    this.props.startConfirmingDeletion(this.props.uri)
  }

  refresh = () => {
    this.props.refresh(this.props.uri)
  }

  renderLeftButtons() {
    return (
      <ButtonToolbar className='pull-left'>
        <Button
          disabled={this.props.addButtonDisabled}
          onClick={this.props.onAdd}
          className='add' // just for unit tests
        >
          {t('New')}
        </Button>
        <Button disabled={this.props.renameButtonDisabled} onClick={this.rename}>
          {t('Rename')}
        </Button>
        <Button disabled={this.props.configureButtonDisabled} onClick={this.configure}>
          {t('Configure')}
        </Button>
        <Button disabled={this.props.deleteButtonDisabled} onClick={this.delete}>
          {t('Delete')}
        </Button>
      </ButtonToolbar>
    )
  }

  render() {
    return (
      <div className='toolbar clearfix'>
        <Row className='no-gutter'>
          <Col className='no-gutter'>{this.renderLeftButtons()}</Col>
          <Col className='no-gutter'>
            <div className='pull-right'>
              <Indicator
                loading={this.props.loading}
                size={this.props.size}
                noun='mail target'
              />
              <ButtonToolbar className='right-button-toolbar'>
                <Button
                  disabled={this.props.refreshButtonDisabled}
                  onClick={this.refresh}
                >
                  {t('Refresh')}
                </Button>
              </ButtonToolbar>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapDbToProps = (db, props) => ({
  loading: loading(db, props.companyKey),
  size: size(db, props.companyKey),
  selected: selected(db, props.companyKey),
  selectedMailTargetLink: selectedMailTargetLink(db, props.companyKey),
  addButtonDisabled: addButtonDisabled(db, props.companyKey),
  renameButtonDisabled: renameButtonDisabled(db, props.companyKey),
  configureButtonDisabled: configureButtonDisabled(db, props.companyKey),
  deleteButtonDisabled: deleteButtonDisabled(db, props.companyKey),
  refreshButtonDisabled: refreshButtonDisabled(db, props.companyKey),
  uri: uri(db, props.companyKey)
})

const mapActionsToProps = (dispatch, initialProps) => ({
  configureMailTarget: (link) =>
    dispatch(configureMailTarget(initialProps.companyKey, link)),
  startConfirmingDeletion: () =>
    dispatch(startConfirmingDeletion(initialProps.companyKey)),
  refresh: (uri) => dispatch(refresh(initialProps.companyKey, uri)),
  onAdd: () => dispatch(startCreating(initialProps.companyKey)),
  editMailTargetName: (link) =>
    dispatch(editMailTargetName(initialProps.companyKey, link))
})

export default connect(mapDbToProps, mapActionsToProps)(Toolbar)
